import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import { Amplify } from "aws-amplify";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments";

if (environment.production) {
	Sentry.init({
		dsn: environment.sentryUrl,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
				networkDetailAllowUrls: [environment.graphqlUri],
			}),
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			environment.sentryTracePropTargetFrontEnd,
			environment.graphqlUri,
		],
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}

Amplify.configure({
	Auth: {
		Cognito: {
			allowGuestAccess: true,
			identityPoolId: environment.identityPoolId,
		},
	},
	API: {
		GraphQL: {
			endpoint: environment.graphqlUri,
			region: "us-east-1",
			defaultAuthMode: "iam",
		},
	},
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
